import type { DeviceListRow } from "../api/devices";

export function deviceDisplayName(device: DeviceListRow): string {
  return (
    device.enrollee?.full_name ||
    device.user?.full_name ||
    device.user?.email ||
    device.model ||
    device.device_uid
  );
}

export function devicePickerMeta(device: DeviceListRow): string {
  const parts: string[] = [];
  const email = device.user?.email;
  if (email && email !== deviceDisplayName(device)) {
    parts.push(email);
  }
  parts.push(device.device_uid);
  parts.push(device.platform.toUpperCase());
  if (device.model) {
    parts.push(device.model);
  }
  return parts.join(" · ");
}

export function memberDisplayName(member: {
  enrollee_full_name?: string | null;
  user_full_name?: string | null;
  user_email?: string | null;
  device_uid: string;
}): string {
  return (
    member.enrollee_full_name ||
    member.user_full_name ||
    member.user_email ||
    member.device_uid
  );
}
